import { Dialog, DialogTitle, DialogContent, DialogActions, Backdrop, CircularProgress, Snackbar, Select, MenuItem, FormControl, InputLabel, OutlinedInput, InputAdornment, Box, Paper, TextField, Button, BottomNavigation, BottomNavigationAction, Typography, Grid, useMediaQuery, useTheme, Card } from "@mui/material"
import axios from "../api/axios"

import SaveAltIcon from '@mui/icons-material/SaveAlt';
import AddCardIcon from '@mui/icons-material/AddCard';
import SearchIcon from '@mui/icons-material/Search';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import InversionistaFind2 from "./InversionistaFind2";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import { useEffect, useState, Fragment } from "react";
import DepositosFind from "./DepositosFind";

export default function Movimientos() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [id, setId] = useState(0)
    const [inversionista, setInversionista] = useState({id:0, label: ''});
    const [inversionistaInput, setInversionistaInput] = useState("")
    const [fecha, setFecha] = useState("1990-01-01")
    const [tipo, setTipo] = useState(1);
    const [monto, setMonto] = useState(0.00);
    const [nota, setNota] = useState("")
    const [mensaje, setMensaje] = useState("")
    const [procesando, setProcesando] = useState(false)
    const [openConfirmacion, setOpenConfirmacion] = useState(false)
    const [openBusqueda, setOpenBusqueda] = useState(false)

    useEffect(() => {
        setFecha(getHoy())
    }, [])

    const blanqueaPantalla = () => {
        setInversionista({id:0, label: ''})
        setFecha(getHoy())
        setTipo(1)
        setMonto(0)
        setNota("")
    }

    const handleCambioInversionista = (value) => {
        setInversionista(value)
    }
    const handleCambioInversionistaInput = (value)=>{
        setInversionistaInput(value)
    }
    const handleCloseMensaje = () => {
        setMensaje("")
    }
    const actionMsg = (
        <Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleCloseMensaje}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </Fragment>
    );

    const handleClickGrabar = () => {
        if (puedeGrabar()) {
            setOpenConfirmacion(true)
        }
    }

    const puedeGrabar = () => {
        let resultado = true;
        if (monto < 1) {
            resultado = false;
            setMensaje("Debe digitar el monto")
        }
        if (inversionista == 0) {
            resultado = false;
            setMensaje("Debe seleccionar el inversionista")
        }
        return resultado;
    }

    const getHoy = () => {
        const cual = new Date();
        var mm = cual.getMonth() + 1;
        var yyyy = cual.getFullYear();
        var dd = cual.getDate();

        if (mm < 10) {
            mm = '0' + mm;
        }
        if (dd < 10) {
            dd = '0' + dd;
        }

        var today = yyyy + '-' + mm + '-' + dd;
        return today;
    }

    const grabar = async () => {
        setOpenConfirmacion(false)
        setProcesando(true)
        try {
            const respuesta = await axios.post("movimientos/grabar", {
                id: id,
                fecha: fecha,
                tipo: tipo,
                nota: nota,
                monto: monto,
                inversionista: inversionista.id
            }, {
                headers: { 'Content-Type': 'application/json' }
            });
            const data = respuesta.data;
            if (data.respuesta == "S") {
                setMensaje("Datos grabados exitosamente")
                setId(0)
                blanqueaPantalla()
            } else {
                setMensaje(data.mensaje)
            }
        } catch (error) {
            console.log(error)
        }
        setProcesando(false)
    }

    const handleCerrarConfirmar = () => {
        setOpenConfirmacion(false)
    }

    const confirmaGrabar = () => {
        return (
            <Dialog
                open={openConfirmacion}
                fullScreen={isMobile}
                PaperProps={{
                    sx: isMobile ? {
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center'
                    } : {}
                }}
            >
                <DialogTitle sx={{
                    background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                    color: 'white',
                    textAlign: 'center',
                    fontWeight: 600
                }}>
                    Confirmacion
                </DialogTitle>
                <DialogContent sx={{
                    py: isMobile ? 4 : 2,
                    px: isMobile ? 3 : 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <Typography sx={{
                        textAlign: 'center',
                        fontSize: isMobile ? '1.1rem' : '1rem',
                        color: '#1e3a5f',
                        mt: 2
                    }}>
                        Desea procesar este deposito?
                    </Typography>
                </DialogContent>
                <DialogActions sx={{
                    flexDirection: isMobile ? 'column' : 'row',
                    gap: isMobile ? 1.5 : 1,
                    p: isMobile ? 3 : 2
                }}>
                    <Button
                        onClick={handleCerrarConfirmar}
                        variant="outlined"
                        fullWidth={isMobile}
                        sx={{
                            order: isMobile ? 2 : 1,
                            color: '#1e3a5f',
                            borderColor: '#1e3a5f',
                            py: isMobile ? 1.5 : 1
                        }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={() => grabar()}
                        variant="contained"
                        fullWidth={isMobile}
                        sx={{
                            order: isMobile ? 1 : 2,
                            background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                            py: isMobile ? 1.5 : 1,
                            '&:hover': {
                                background: 'linear-gradient(135deg, #2c5282 0%, #3d6a9f 100%)'
                            }
                        }}
                    >
                        Grabar!
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    const handleClickBuscar = ()=>{
        setOpenBusqueda(true)
    }

    const handleCerrarBusqueda = () => {
        setOpenBusqueda(false)
    }

    const handleSeleccionBusqueda = (cual) => {
        inicio(cual)
        setOpenBusqueda(false)

    }

    const objWait = () => {
        return (
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={procesando}
                onClick={()=>{setProcesando(false)}}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        )
    }

    const inicio = async (cual)=>{
        setProcesando(true)
        try {
            const respuesta = await axios.post("movimientos/inicio", {
                cual: cual
            }, {
                headers: { 'Content-Type': 'application/json' }
            });
            const data = respuesta.data;
            if (data.respuesta=="S"){
                setId(cual)
                setInversionista({id: data.inversionista, label: data.nombre})
                setNota(data.nota)
                setMonto(data.monto)
                setFecha(data.fecha)
            } else {
                setMensaje(data.mensaje)
            }
        } catch(error){
            console.log(error)
        }
        setProcesando(false)
    }

    return (
        <Box sx={{
            p: isMobile ? 1 : 2,
            display: 'flex',
            justifyContent: 'center'
        }}>
            <Box sx={{
                width: '100%',
                maxWidth: isMobile ? '100%' : { sm: '100%', md: 500, lg: 620, xl: 720 }
            }}>
                <Snackbar
                    open={mensaje.length == 0 ? false : true}
                    autoHideDuration={6000}
                    onClose={handleCloseMensaje}
                    action={actionMsg}
                    message={mensaje}
                    sx={isMobile ? { bottom: 70 } : {}}
                />
                {openBusqueda && <DepositosFind open={openBusqueda} cerrar={handleCerrarBusqueda} seleccion={handleSeleccionBusqueda} />}
                {confirmaGrabar()}
                {objWait()}

                {/* Header con titulo */}
                <Paper sx={{
                    p: isMobile ? 1.5 : 1,
                    mb: 1.5,
                    borderRadius: 2,
                    boxShadow: 2,
                    background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)'
                }}>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 1
                    }}>
                        <AccountBalanceWalletIcon sx={{ color: '#d4af37', fontSize: isMobile ? 28 : 24 }} />
                        <Typography
                            variant={isMobile ? 'h6' : 'subtitle1'}
                            sx={{
                                color: 'white',
                                fontWeight: 700,
                                letterSpacing: 0.5
                            }}
                        >
                            Depositos Inversionistas
                        </Typography>
                    </Box>
                </Paper>

                {/* Barra de acciones */}
                <Paper sx={{ mb: 1.5, borderRadius: 2, boxShadow: 2 }}>
                    <BottomNavigation
                        sx={{
                            borderRadius: 2,
                            height: isMobile ? 56 : 48,
                            '& .MuiBottomNavigationAction-root': {
                                minWidth: isMobile ? 'auto' : 80,
                                padding: '4px 8px',
                                color: '#1e3a5f',
                                '&.Mui-selected': {
                                    color: '#d4af37'
                                }
                            },
                            '& .MuiBottomNavigationAction-label': {
                                fontSize: isMobile ? '0.75rem' : '0.7rem'
                            },
                            '& .MuiSvgIcon-root': {
                                fontSize: isMobile ? '1.5rem' : '1.2rem'
                            }
                        }}
                        showLabels
                        onChange={(event, newValue) => {
                            if (newValue === 0) { blanqueaPantalla(); setId(0) }
                            if (newValue === 1) { handleClickGrabar() }
                            if (newValue === 2) { handleClickBuscar() }
                        }}
                    >
                        <BottomNavigationAction
                            label="Nuevo"
                            icon={<SaveAltIcon />}
                        />
                        <BottomNavigationAction
                            label="Grabar"
                            icon={<AddCardIcon />}
                        />
                        <BottomNavigationAction
                            label="Buscar"
                            icon={<SearchIcon />}
                        />
                    </BottomNavigation>
                </Paper>

                {/* Formulario principal */}
                <Paper sx={{ p: isMobile ? 2 : 2, borderRadius: 2, boxShadow: 2 }}>
                    <Grid container spacing={isMobile ? 2 : 1.5}>
                        {/* Selector de Inversionista */}
                        <Grid item xs={12}>
                            <Typography variant="caption" sx={{ color: '#1e3a5f', mb: 0.5, fontWeight: 600, display: 'block' }}>
                                Inversionista
                            </Typography>
                            <InversionistaFind2
                                value={inversionista}
                                inputValue={inversionistaInput}
                                handleCambio={handleCambioInversionista}
                                handleCambioInput={(value)=>{setInversionistaInput(value)}}
                            />
                        </Grid>

                        {/* Fecha y Tipo en una fila */}
                        <Grid item xs={6}>
                            <Box sx={{
                                p: isMobile ? 1.5 : 1,
                                borderRadius: 1,
                                backgroundColor: '#f8fafc',
                                border: '1px solid #e2e8f0'
                            }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
                                    <CalendarTodayIcon sx={{ color: '#1e3a5f', fontSize: 16 }} />
                                    <Typography variant="caption" sx={{ color: '#1e3a5f', fontWeight: 600 }}>
                                        Fecha
                                    </Typography>
                                </Box>
                                <OutlinedInput
                                    type="date"
                                    value={fecha}
                                    onChange={(event)=>{setFecha(event.target.value)}}
                                    fullWidth
                                    size="small"
                                    sx={{
                                        backgroundColor: 'white',
                                        '& .MuiInputBase-input': {
                                            py: 0.75,
                                            fontSize: '0.85rem'
                                        },
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#1e3a5f'
                                        },
                                        '&:hover .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#d4af37'
                                        }
                                    }}
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={6}>
                            <Box sx={{
                                p: isMobile ? 1.5 : 1,
                                borderRadius: 1,
                                backgroundColor: '#f8fafc',
                                border: '1px solid #e2e8f0'
                            }}>
                                <Typography variant="caption" sx={{ color: '#1e3a5f', fontWeight: 600, mb: 0.5, display: 'block' }}>
                                    Tipo
                                </Typography>
                                <Select
                                    fullWidth
                                    size="small"
                                    disabled
                                    value={tipo}
                                    onChange={(event) => { setTipo(event.target.value) }}
                                    sx={{
                                        backgroundColor: 'white',
                                        '& .MuiSelect-select': {
                                            py: 0.75,
                                            fontSize: '0.85rem'
                                        },
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#1e3a5f'
                                        }
                                    }}
                                >
                                    <MenuItem value={1}>Deposito</MenuItem>
                                    <MenuItem value={2}>Retiro</MenuItem>
                                </Select>
                            </Box>
                        </Grid>

                        {/* Campo Nota */}
                        <Grid item xs={12}>
                            <Box sx={{
                                p: isMobile ? 1.5 : 1,
                                borderRadius: 1,
                                backgroundColor: '#f8fafc',
                                border: '1px solid #e2e8f0'
                            }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
                                    <NoteAltIcon sx={{ color: '#1e3a5f', fontSize: 16 }} />
                                    <Typography variant="caption" sx={{ color: '#1e3a5f', fontWeight: 600 }}>
                                        Nota / Comentario
                                    </Typography>
                                </Box>
                                <OutlinedInput
                                    value={nota}
                                    onChange={(event) => { setNota(event.target.value) }}
                                    fullWidth
                                    size="small"
                                    placeholder="Escriba una nota o comentario..."
                                    sx={{
                                        backgroundColor: 'white',
                                        '& .MuiInputBase-input': {
                                            py: 0.75,
                                            fontSize: '0.85rem'
                                        },
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#1e3a5f'
                                        },
                                        '&:hover .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#d4af37'
                                        }
                                    }}
                                />
                            </Box>
                        </Grid>

                        {/* Campo Monto - Destacado */}
                        <Grid item xs={12}>
                            <Box sx={{
                                p: isMobile ? 2 : 1.5,
                                borderRadius: 1,
                                background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                                textAlign: 'center'
                            }}>
                                <Typography variant="caption" sx={{ color: '#d4af37', fontWeight: 600, mb: 1, display: 'block' }}>
                                    MONTO DEL DEPOSITO
                                </Typography>
                                <OutlinedInput
                                    type="number"
                                    value={monto}
                                    onChange={(event) => { setMonto(event.target.value) }}
                                    startAdornment={
                                        <InputAdornment position="start">
                                            <Typography sx={{ color: '#d4af37', fontWeight: 'bold', fontSize: isMobile ? '1.1rem' : '0.95rem' }}>
                                                RD$
                                            </Typography>
                                        </InputAdornment>
                                    }
                                    sx={{
                                        width: '100%',
                                        backgroundColor: 'white',
                                        borderRadius: 1,
                                        '& .MuiInputBase-input': {
                                            fontSize: isMobile ? '1.5rem' : '1.3rem',
                                            fontWeight: 'bold',
                                            textAlign: 'center',
                                            color: '#1e3a5f',
                                            py: isMobile ? 1 : 0.75
                                        },
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#d4af37',
                                            borderWidth: 2
                                        },
                                        '&:hover .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#d4af37'
                                        },
                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#d4af37'
                                        }
                                    }}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Paper>
            </Box>
        </Box>
    )
}
